<div mat-dialog-title>Create Landlord</div>

<mat-dialog-content class="fx-col fx-gap-20">

  <div class="heading-bold">Company Details</div>

  <div class="fx-row full-width fx-gap-10">
    <mat-form-field class="fx-flex-1">
      <mat-label>Company Name</mat-label>
      <input matInput [formControl]="form.controls.companyName" placeholder="e.g. Acme Properties" />
      <mat-error>Company name is required</mat-error>
    </mat-form-field>

    <mat-form-field class="fx-flex-1">
      <mat-label>Landlord Code</mat-label>
      <input matInput [formControl]="form.controls.landlordCode" placeholder="e.g. acme-properties" />
      <button mat-icon-button matSuffix type="button"
              matTooltip="Auto-generate code from the company name"
              aria-label="Generate code from name"
              (click)="generateCode()">
        <mat-icon>auto_fix_normal</mat-icon>
      </button>
      <mat-error>Landlord code is required</mat-error>
    </mat-form-field>
  </div>

  <div class="fx-row full-width fx-gap-10">
    <mat-form-field class="fx-flex-1">
      <mat-label>Country</mat-label>
      <mat-select [formControl]="form.controls.country">
        @for (c of countries; track c.code) {
          <mat-option [value]="c.code">{{ c.name }}</mat-option>
        }
      </mat-select>
      <mat-error>Country is required</mat-error>
    </mat-form-field>

    <mat-form-field class="fx-flex-1">
      <mat-label>Registration Number</mat-label>
      <input matInput [formControl]="form.controls.registrationNumber" placeholder="e.g. 2024/123456/07" />
    </mat-form-field>
  </div>

  <mat-form-field class="full-width">
    <mat-label>Address</mat-label>
    <input
      matInput
      matGoogleMapsAutocomplete
      [formControl]="form.controls.address"
      placeholder="Start typing an address..."
      (onAutocompleteSelected)="onAutocompleteSelected($event)"
      (onLocationSelected)="onLocationSelected($event)"
    />
    <mat-error>Address is required</mat-error>
  </mat-form-field>

  <div class="fx-col fx-gap-10">
    <span>Logo <span style="color: var(--mat-sys-on-surface-variant); font-size: 0.85em;">(optional — can be added later in Landlord Settings)</span></span>
    <div class="fx-row fx-v-center fx-gap-10">
      <button mat-stroked-button type="button" (click)="logoFileInput.click()">
        <mat-icon>upload</mat-icon> Choose File
      </button>
      @if (logoFile) {
        <span>{{ logoFile.name }}</span>
        <button mat-icon-button type="button" aria-label="Remove logo" (click)="clearLogoFile()">
          <mat-icon>close</mat-icon>
        </button>
      } @else {
        <span style="color: var(--mat-sys-on-surface-variant);">No file chosen</span>
      }
    </div>
    <input #logoFileInput type="file" accept="image/*" hidden (change)="onLogoSelected($event)" />
  </div>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()" [disabled]="loader.loading$ | async">Cancel</button>
  <button mat-flat-button class="button-primary" (click)="onSubmit()" [disabled]="loader.loading$ | async">
    Create Landlord
  </button>
</mat-dialog-actions>
